import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { renderDate } from '../util';
import { HitProps } from './_types';
import { HitHeadline } from './_HitHeading';
import ImageWrapper from 'components/helpers/ImageWrapper/ImageWrapper';

export const EventListingHit = ({ hit }: HitProps) => {
  const [firstCategory, ...otherCategories] = hit.eventCategory || [];

  return (
    <div>
      <div className={classnames('md:flex', 'grid-cols-3', 'md:gap-5', 'lg:gap-7')}>
        <div className={classnames('flex-none', 'w-64', 'hidden', 'md:block')}>
          <ImageWrapper
            field={{ value: { src: hit.featuredImage, width: '256px', height: '151px' } }}
          />
        </div>
        <div className={classnames('flex-1', 'overflow-hidden')}>
          <div className={classnames('mb-2')}>
            {firstCategory}
            {otherCategories.length ? <> &emsp;| &emsp; {otherCategories.join(', ')}</> : ''}
          </div>
          <HitHeadline hit={hit}>
            <Highlight hit={hit} attribute="pageTitle" />
          </HitHeadline>
          {renderDate(hit.startDate)}
          <Snippet
            hit={hit}
            attribute="description"
            className={classnames('line-clamp-4', 'md:line-clamp-2')}
          />
        </div>
      </div>
    </div>
  );
};
